export default __webpack_public_path__ + "static/media/kitchen4-afterA-480w.8530ee73.avif";